export const HREF_CONSTANTS = {
    INTEGRATION_OUTLOOK: 'integration=outlook',
    INTEGRATION_WORD: 'integration=word',
}
